import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDatasourceTypesIdsSelector, setSelectedDatasourceTypesIds } from '../filtersSlice';

export const useSelectedDatasourceTypesIds = () => {
  const dispatch = useDispatch();
  const datasourceTypesIds = useSelector(selectedDatasourceTypesIdsSelector);

  const onChangeDatasourceTypesIds = React.useCallback((ids: number[] | undefined) => {
    dispatch(setSelectedDatasourceTypesIds(ids));
  }, [dispatch]);
  return {
    datasourceTypesIds,
    onChangeDatasourceTypesIds,
  };
};
